import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

export const HelpCenterFeature = () => {
    return (
        <div
            className="eStoreHelp"
            style={{
                backgroundImage: `url('/estore/images/help_center/bkgd-bokeh-08.jpg')`,
            }}
        >
            <div className="eStoreHelp-content">
                <p>
                    <FormattedMessage
                        id="Need_help_help_center_feature"
                        defaultMessage="Need help with an order?"
                    />
                    <br />
                    <FormattedMessage
                        id="Questions_about_help_center_feature"
                        defaultMessage="Questions about how to do something on the eStore?"
                    />
                    <br />
                    <FormattedMessage
                        id="View_help_center_feature"
                        defaultMessage="View our new Help Center!"
                    />
                </p>
            </div>
            <div className="eStoreHelp-button">
                <Link to="/my-account/help-center" className="btn btn-primary">
                    <FormattedMessage
                        id="Help_Center"
                        defaultMessage="Help Center"
                    />
                </Link>
            </div>
        </div>
    );
};

export default HelpCenterFeature;
